export default __webpack_public_path__ + "static/media/eb-ultra-wht-2.7cfd672c.png";